export default "__VITE_ASSET__BFjaaspY__"